module.exports = __webpack_public_path__ + "static/assets/31fc60412c9b904fb1e9f1d4d932a4e2.gif";